var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttribute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Attribute"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8125 18.8V16.925H14.95L18.45 12L14.95 7.07501H5.125V10.1875H3.25V5.20001H15.925L20.75 12L15.925 18.8H11.8125ZM5.0625 19.9375V16.9375H2.0625V15.0625H5.0625V12.0625H6.9375V15.0625H9.9375V16.9375H6.9375V19.9375H5.0625Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttribute);
export default __webpack_public_path__ + "static/media/icon-attribute.b50b734f88b2fcb2405bce88e166aa9e.svg";
export { ForwardRef as ReactComponent };